import { jsx, jsxs } from "react/jsx-runtime";
import { O as ObjectProperties } from "../../../../index-5e4e4f4b.js";
import { c as classNames } from "../../../../index-e71f83b5.js";
import React__default, { useRef } from "react";
import { T as TooltipPopoverWrapper, p as propTypes$1 } from "../../../../TooltipPopoverWrapper-857e7584.js";
import { t as tagPropType, P as PropTypes, m as mapToCssModules } from "../../../../utils-65a8d69b.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import { useInsightsImpression } from "../../../../hooks/useInsights/useInsightsImpression.js";
import { analyticsEventForImpression } from "../../../../hooks/useInsights/utils.js";
import { useOutsideClickHandler } from "../../../../hooks/useOutsideClickHandler/useOutsideClickHandler.js";
import { noOp } from "../../../../utils/noOp.js";
import "../../../../axios-5f69b112.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "react-dom";
import "../../../../Popper-b45e70f5.js";
import "../../../../Manager-52cb3832.js";
import "../../../../Fade-5a502c0e.js";
import "../../../../Transition-a28a969d.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$1.apply(this, arguments);
}
var defaultProps = {
  placement: "right",
  placementPrefix: "bs-popover",
  trigger: "click",
  offset: [0, 8]
};
function Popover(props) {
  var arrowClasses = classNames("popover-arrow", props.arrowClassName), popperClasses = classNames("popover", "show", props.popperClassName), classes = classNames("popover-inner", props.innerClassName);
  return /* @__PURE__ */ React__default.createElement(TooltipPopoverWrapper, _extends$1({}, props, {
    arrowClassName: arrowClasses,
    popperClassName: popperClasses,
    innerClassName: classes
  }));
}
Popover.propTypes = propTypes$1;
Popover.defaultProps = defaultProps;
var _excluded = ["className", "cssModule", "tag"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes = {
  tag: tagPropType,
  className: PropTypes.string,
  cssModule: PropTypes.object
};
function PopoverBody(props) {
  var className = props.className, cssModule = props.cssModule, _props$tag = props.tag, Tag = _props$tag === void 0 ? "div" : _props$tag, attributes = _objectWithoutProperties(props, _excluded), classes = mapToCssModules(classNames(className, "popover-body"), cssModule);
  return /* @__PURE__ */ React__default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
PopoverBody.propTypes = propTypes;
function FlashPopover(props) {
  const {
    target,
    isOpen,
    placement = "bottom-start",
    children,
    onOutsideClick = noOp,
    className,
    bodyProps = {},
    analytics,
    matchTargetWidth,
    /* eslint-disable @typescript-eslint/no-unused-vars --
     *   we don't use these props directly, but need to remove them from ...rest */
    open,
    close,
    toggle,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    ...rest
  } = props, { className: bodyClassName, style: bodyStyle, ...bodyPropsRest } = bodyProps, ref = useRef(null);
  useOutsideClickHandler({ ref, onOutsideClick });
  const { impressionRef } = useInsightsImpression(
    analyticsEventForImpression(analytics, ObjectProperties.MODAL),
    analytics == null ? void 0 : analytics.impressionOptions
  ), targetElement = typeof target == "string" ? void 0 : target instanceof HTMLElement ? target : target.current, usedTargetId = targetElement ? targetElement.id : target, targetWidth = targetElement == null ? void 0 : targetElement.getBoundingClientRect().width, matchedTargetWidth = matchTargetWidth ? targetWidth : void 0;
  return /* @__PURE__ */ jsx(
    Popover,
    {
      ...rest,
      innerRef: ref,
      target,
      "data-testid": `${usedTargetId}-popover`,
      isOpen,
      placement,
      hideArrow: !0,
      className: classNames(COMMON_CLASSNAME, "flash-popover", className),
      style: { width: matchedTargetWidth },
      children: /* @__PURE__ */ jsxs(
        PopoverBody,
        {
          className: classNames(COMMON_CLASSNAME, "flash-popover-body", bodyClassName),
          style: { ...bodyStyle, width: matchedTargetWidth },
          ...bodyPropsRest,
          children: [
            /* @__PURE__ */ jsx("div", { ref: impressionRef }),
            children
          ]
        }
      )
    }
  );
}
export {
  FlashPopover as default
};
//# sourceMappingURL=FlashPopover.js.map
